import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import type { FlightInfoServerSuccessResponse } from '@/modules/Search/types/api/response/flightInfo'
import { axiosInstance } from '@/modules/Core/plugins/axios'

const QUERY_KEY = 'flight-info'
const ENDPOINT = '/Search/FlightInfo'

const STALE_TIME = 1000 * 10

export function fetchFlightInfo(
  searchId: string,
  searchOption: number,
  customerCode: string
) {
  return axiosInstance
    .get<FlightInfoServerSuccessResponse>(ENDPOINT, {
      params: {
        searchId,
        searchOption,
        customerCode,
      },
    })
    .then((response) => response.data)
}

export function useFlightInfoQuery(
  searchId: Ref<string>,
  searchOption: Ref<number>,
  customerCode: Ref<string>,
  options?: UseQueryOptions<Awaited<ReturnType<typeof fetchFlightInfo>>>
) {
  return useQuery({
    queryKey: [QUERY_KEY, searchId, searchOption, customerCode],
    queryFn: () =>
      fetchFlightInfo(searchId.value, searchOption.value, customerCode.value),
    keepPreviousData: true,
    staleTime: STALE_TIME,
    ...options,
  })
}
